export default "__VITE_ASSET__82dbba9c__"